export enum ActionType {
  API_CALL = 'API_CALL',
  BULK_API_CALL = 'BULK_API_CALL',
}
